import {
  isNonEmptyArray,
  isNonEmptyObject,
  isNonEmptyString
} from '@/utils/checks'
import { RefinementList } from './types'

interface GetLocationStringFromRefinementList {
  (refinementList: RefinementList): string
}

const getLocationStringFromRefinementList: GetLocationStringFromRefinementList =
  (refinementList) => {
    if (isNonEmptyObject(refinementList)) {
      const { locations } = refinementList

      if (isNonEmptyString(locations)) {
        return locations
      }

      if (isNonEmptyArray(locations)) {
        return locations.join(', ')
      }
    }

    return ''
  }

export default getLocationStringFromRefinementList
